<script setup>
// Va justo después de "Cómo medir" a propósito: es el único punto de la página
// donde alguien ya tiene el ancho y el alto anotados.
import QuoteForm from '@/components/QuoteForm.vue'

defineProps({
  phone: { type: String, required: true }
})
</script>

<template>
  <section id="cotizar" class="bg-linen text-ink scroll-mt-16">
    <div class="mx-auto max-w-7xl px-6 py-16 lg:px-10 lg:py-24">
      <!-- El borde va en este envoltorio de ancho completo, no en el header:
           así el divisor cruza toda la sección (igual que el del CTA de arriba)
           en vez de quedar corto pegado al header angosto. -->
      <div class="border-t border-ink/12 pt-12">
        <header class="max-w-2xl">
          <p class="eyebrow text-glow-ink">Cotización sin costo</p>
          <h2 class="display mt-4 text-balance text-[clamp(1.9rem,4vw,3rem)]">
            Pide tu presupuesto
          </h2>
          <p class="mt-4 leading-relaxed text-ink-soft">
            Con tus medidas te preparamos el presupuesto por escrito, ventana por
            ventana. Te llega una copia a tu correo.
          </p>
        </header>

        <!-- La caja del formulario sí va centrada: es un bloque angosto para
             que una sola columna de campos se lea cómoda, no a lo ancho del
             max-w-7xl. -->
        <div class="mx-auto mt-10 max-w-3xl">
          <QuoteForm :phone="phone" />
        </div>
      </div>
    </div>
  </section>
</template>
